import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useCallback } from 'react';
import { ARROW_DOWN, ARROW_UP, ENTER, ESCAPE, SPACE } from '../../constants';
import { callAll } from '../../utils';
import { States, useDropdown } from './Context';
import { CLOSE_MENU, GO_TO_NEXT_ITEM, GO_TO_PREV_ITEM, OPEN_MENU } from './constants';
const Button = forwardRef(({ as: Element = 'button', children, className, onClick = () => { }, onKeyDown = () => { }, ...rest }, ref) => {
    const { id, state, dispatch, items, activeItemIndex } = useDropdown();
    const handleClick = useCallback(() => dispatch({ type: state === States.Open ? CLOSE_MENU : OPEN_MENU }), [dispatch, state]);
    const handleKeydown = useCallback((evt) => {
        switch (evt.key) {
            case ENTER:
            case SPACE: {
                evt.preventDefault();
                if (items[activeItemIndex]) {
                    const activeItem = items[activeItemIndex].element;
                    activeItem === null || activeItem === void 0 ? void 0 : activeItem.click();
                }
                dispatch({ type: state === States.Closed ? OPEN_MENU : CLOSE_MENU });
                break;
            }
            case ARROW_DOWN: {
                evt.preventDefault();
                dispatch({ type: OPEN_MENU });
                dispatch({ type: GO_TO_NEXT_ITEM });
                break;
            }
            case ARROW_UP: {
                evt.preventDefault();
                dispatch({ type: OPEN_MENU });
                setTimeout(() => dispatch({ type: GO_TO_PREV_ITEM }), 0);
                break;
            }
            case ESCAPE: {
                evt.preventDefault();
                dispatch({ type: CLOSE_MENU });
                break;
            }
            default:
                break;
        }
    }, [dispatch, state, activeItemIndex, items]);
    return (_jsx(Element, { ref: ref, className: className, "aria-expanded": state === States.Open, "aria-controls": `dropdown-${id}-items`, "data-open": state === States.Open, id: `dropdown-${id}-button`, "aria-haspopup": true, onClick: callAll(onClick, handleClick), onKeyDown: callAll(onKeyDown, handleKeydown), ...rest, children: children }));
});
Button.displayName = 'Button';
export { Button };
//# sourceMappingURL=Button.js.map